import {createReducer} from '@reduxjs/toolkit'
import {UserConfig} from '../types/state'

const defaultState: UserConfig = {
  currentUserId: '',
  viewedSiteMemberId: '',
}

export const user = createReducer(defaultState, () => {})
